// globals
const e_root = document.querySelector(':root');

window.addEventListener('load', () => {
  e_root.style.setProperty('--firstViewHeight', `${window.innerHeight}px`);
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})

window.addEventListener('resize', () => {
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})
class Works {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
  
  }
}

var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).parent().parent().parent().next().addClass('c-accordion__inner').css({'display': 'none'});
    $("." + this.el).parent().parent().parent().parent().addClass('c-accordion__wrap')

    $("." + this.el).on('click', function() {
      $(this).toggleClass('is-active');
      $(this).parent().parent().parent().next().slideToggle();
    })
  }
}
class Editor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-editor p, .c-editor div').each(function(index, el) {
      if(el.textContent == ' ' || el.textContent == '') {
        el.style.height = '1px';
        el.style.marginTop = '1.5rem';
      }
    })
  }
}
class Loading {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const body = document.getElementsByTagName('body')[0];
    const btn = document.getElementById('btn');
    let scrollTop = 0;
    
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('no_scroll');
    
    setTimeout(() => {
      $(".c-loading").fadeOut(500);
      body.style.top = '';
      body.classList.remove('no_scroll');
      window.scrollTo(0, scrollTop);
    }, 800);
  }
}
class Modal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(function() {
      $('.c-modal-trigger').modaal({
          type: 'image',
          animation_speed: 300,
          background: '#fff',
	        overlay_opacity: '0.5',
      });
    });
  }
}
class Slider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.c-swiper', {
      speed: 500,
      loop: true,
      autoplay: {
        delay: 5000,  
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    })
  }
}

class Tab {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-tab-trigger').parent().parent().parent().addClass('u-mb-0');
    $(".c-tab-inner").parent().addClass('c-tab-wrap');
    $(".c-tab-wrap").eq(0).css({'display': 'block'});

    $(".c-tab-trigger li").on('click', function() {
      let el_num = $(this).index();
      $(".c-tab-trigger li").removeClass('is-active');
      $(this).addClass('is-active');

      $('.c-tab-wrap').css({'display': 'none'});
      $('.c-tab-wrap').eq(el_num).css({'display': 'block'});
    })
  }
}
//noScroll
class Common {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // let elFs;

    // $('.c-content *').each(function() {

    //   let css = ['font-size', 'padding-left', 'padding-top', 'padding-right', 'padding-bottom', 'margin-left', 'margin-top', 'margin-right', 'margin-bottom']
    //   let this_el = $(this);

    //   css.forEach(el => {
    //     elFs = this_el.css(el);
    //     if(elFs.match(/([0-9]*)\.[0-9]*(px)/)) {
    //       elFs = elFs.replace(/([0-9]*)\.[0-9]*(px)/, '$1$2');          
    //     }
    //     elFs = elFs.replace(/([0-9])px/, '.$1rem');
    //     this_el.css(el, elFs);
    //   });

    //   // height
    //   if($(this).prop('nodeName').match(/TABLE|TD|TR|TBODY/)) {
    //     elFs = $(this).css('height');
    //     if(elFs.match(/([0-9]*)\.[0-9]*(px)/)) {
    //       elFs = elFs.replace(/([0-9]*)\.[0-9]*(px)/, '$1$2');          
    //     }
    //     elFs = elFs.replace(/([0-9])px/, '.$1rem');
    //     $(this).css('height', elFs);
    //   }
    // })  

    // $('.c-content p').each(function() {
    //   if($(this)[0].innerHTML == '&nbsp;') {
    //     $(this)[0].innerHTML = '';
    //   }
    // });
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class FormCheckbox {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // const checkBox = document.querySelector('.mwform-checkbox-field-text');
    // checkBox.innerHTML = `<span><a href="https://www.nico-d.net/privacy-policy" name="consent" target="_blank" class="policy-link">個人情報保護方針</a>に同意します。</span>`
  }
}

class HamburgerMenu {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const humBtn = document.querySelector('.js-hum');
    const humMenu = document.querySelector('.humMenu');
    const body = document.querySelector('body');
    const item01 = document.querySelector('.item1')
    const item02 = document.querySelector('.item2')
    const item03 = document.querySelector('.item3')
    const item04 = document.querySelector('.item4')
    const item05 = document.querySelector('.item5')
    const item06 = document.querySelector('.item6')
    const item07 = document.querySelector('.item7')
    const item08 = document.querySelector('.item8')

    humBtn.addEventListener('click', ()=> {
      humMenu.classList.toggle('is-active');
      humBtn.classList.toggle('is-active');
      body.classList.toggle('no-scroll');
      setTimeout(() => {
        item01.classList.toggle('is-active');
      },580);
      setTimeout(() => {
        item02.classList.toggle('is-active');
      },630);
      setTimeout(() => {
        item03.classList.toggle('is-active');
      },680);
      setTimeout(() => {
        item04.classList.toggle('is-active');
      },730);
      setTimeout(() => {
        item05.classList.toggle('is-active');
      },780);
      setTimeout(() => {
        item06.classList.toggle('is-active');
      },830);
      setTimeout(() => {
        item07.classList.toggle('is-active');
      },930);
      setTimeout(() => {
        item08.classList.toggle('is-active');
      },930);
    })
  }
}

//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class MvSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let speed = 4000;
    const swiper = new Swiper(".s-mv-swiper", {
      loop: true,
      effect: 'fade',
      speed: 1500,
      autoplay: {
        delay: speed,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
        renderFraction: function (currentClass, totalClass) {
          return '<span class="' + currentClass + '"></span>' + '<span class="swiper-pagination-border js-border"><span></span></span>' + '<span class="' + totalClass + '"></span>';
        }
      },
      on: {
        init: function () {
          setTimeout(() => {
            const pagiNation = document.querySelector('.swiper-pagination');
            pagiNation.classList.add('is-active');
          }, 100);
        },
        slideChangeTransitionStart: function () {
          setTimeout(() => {
            const border = document.querySelector('.js-border span');
            if (border) {
              border.style.transform = 'scaleX(0)';
              border.style.transitionDuration = '0s';
            }
          }, 100);
        },
        slideChangeTransitionEnd: function () {
          setTimeout(() => {
            const border = document.querySelector('.js-border span');
            if (border) {
              border.style.transform = 'scaleX(1)';
              border.style.transitionDuration = speed + "ms";
            }
          }, 100);
        },
      },
    });
  }
}

class ServiceSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const windowWidth = $(window).width();
    const windowSm = 768;
    if (windowWidth <= windowSm) {
      const swiper = new Swiper(".s-service__swiper", {
        slidesPerView: 1,
        spaceBetween: 30,
      
        // ナビボタンが必要なら追加
        navigation: {
          nextEl: ".s-service__swiper-button-next",
          prevEl: ".s-service__swiper-button-prev",
        },

        scrollbar: {
          el: ".s-service__swiper-scrollbar",
          hide: false,
          draggable: true 
        },
      });
    } else {
    }
  }
}

class SingleWorkSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // const swiperNum = document.querySelectorAll(".swiper-slide");
    // if( swiperNum.length === 0  ){
    //   const worksGallery = document.querySelector(".p-single-swiper");
    //   worksGallery.classList.add("is-hidden");
    // }
    // const swiper = new Swiper(".p-single-swiper", {
    //   slidesPerView: 1,
    //   spaceBetween: 24,
    //   centeredSlides: true,
    //   speed: 800,      
    //   breakpoints: {
    //     spaceBetween: 50,
    //     768: {
    //       slidesPerView: 1.3,
    //     }
    //   },
    //   scrollbar: {
    //     el: ".swiper-scrollbar",
    //     hide: false,
    //     draggable: true 
    //   },
    
    //   // ナビボタンが必要なら追加
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    //   },
    // });

    
    if ($('.slider').length > 0) {
      const $slider = $('.slider'); // $sliderを定義
      const $current = $('.swiper-scrollbar .current'); // $currentを定義
    
      $slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 800,
        arrows: true,
        centerMode: true,
        centerPadding: '25%',
        variableWidth: true,
        prevArrow: '.swiper-button-prev', // 前へボタン
        nextArrow: '.swiper-button-next', // 次へボタン
        infinite: false,

        responsive: [
          {
            breakpoint: 768, // 768px以下の場合
            settings: {
              centerMode: true,
              centerPadding: '15%',
            }
          }
        ]
      });
    
      function updateScrollbar(currentSlide, slideCount) {
        const percentage = ((currentSlide + 1) / slideCount) * 100;
        $current.css('width', `${percentage}%`);
      }
    
      // 初期化時
      const slideCount = $slider.slick('getSlick').slideCount;
      updateScrollbar(0, slideCount);
    
      // スライド変更時
      $slider.on('afterChange', function (event, slick, currentSlide) {
        updateScrollbar(currentSlide, slick.slideCount);
      });
    }
    



    // if( 3 < swiperNum.length ){
    //   const swiperBtn = document.querySelector(".single-works__swiper-naviWrap");
    //   swiperBtn.classList.add("is-hidden");
    // }

    // if( swiperNum.length === 0  ){
    //   const worksGallery = document.querySelector(".single-works__gallery");
    //   worksGallery.classList.add("is-hidden");
    // }

    // const swiper = new Swiper(".p-single-swiper", {
    //   slidesPerView: 1,
    //   spaceBetween: 24,
    //   speed: 800,      
    //   breakpoints: {
    //     spaceBetween: 50,
    //     768: {
    //       slidesPerView: 2.4,
    //     }
    //   },
    //   scrollbar: {
    //     el: ".swiper-scrollbar",
    //     hide: false,
    //     draggable: true 
    //   },
    
    //   // ナビボタンが必要なら追加
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    //   },
    // });

  }
}


class SplitText {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const windowWidth = $(window).width();
    const windowSm = 768;
    if (windowWidth <= windowSm) {
    //横幅768px以下（スマホ）に適用させるJavaScriptを記述
    
    } else {
      var elm = document.createElement("p");
      var txt = document.createTextNode("\u00a0");
      elm.appendChild(txt);
      document.body.appendChild(elm);

      let splitTarget = document.querySelectorAll('.js-splitText'); //ターゲットとなる要素を全取得
      splitTarget.forEach((target) => {
        if(!target.classList.contains('is-active')){ //ターゲットが'is-active'クラスを持っていない場合
          let newText = ''; //生成する要素を格納するための変数
          const spanText = target.innerHTML; //ターゲットの中身を取得
  
          spanText.split('').forEach((char) => { // char = character 文字
            newText += '<span>' + char + '</span>'; //一文字ずつspanタグで囲む
          });
  
          const newTextBefore = "<div class='before'>"+newText+"</div>"; //beforeクラスをつけた要素を生成
          const newTextAfter = "<div class='after'>"+newText+"</div>"; //afterクラスをつけた要素を生成
          newText = "<span class='text-wrap'>"+newTextBefore + newTextAfter+"</span>"; //before after両要素を囲む要素生成
          target.innerHTML = newText; //ターゲットに生成した要素を挿入
        }
      });
  
      /* ターゲットにホバーした時の動き */
      splitTarget.forEach((target)=>{
        if(!target.classList.contains('is-active')){//ターゲットが'is-active'クラスを持っていない場合
          let beforeSpan = target.querySelector('.before').querySelectorAll('span');//beforeの中にあるspanタグを全取得
          let afterSpan = target.querySelector('.after').querySelectorAll('span');//afterの中にあるspanタグを全取得
          target.addEventListener('mouseenter',()=>{//ホバーしたとき
            gsap.to(beforeSpan,{y:'-100%',stagger:.03,ease:"power2.out"})//0.03秒おきに各spanタグをy軸上に移動
            gsap.to(afterSpan,{y:'0%',stagger:.03,ease:"power2.out"})
          })
          target.addEventListener('mouseleave',()=>{//ホバーが外れたとき
            gsap.to(beforeSpan,{y:'0%',stagger:.03,ease:"power2.out"})
            gsap.to(afterSpan,{y:'100%',stagger:.03,ease:"power2.out"})
          })
        }
      })
    }
  }
}

class TopLoading {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const topLoading = document.querySelector(".topLoading");
    const header = document.querySelector(".l-header");
    const sideTxt = document.querySelector(".sideTxt");
    const humMenu = document.querySelector(".js-hum");
    const mv = document.querySelector(".s-mv");

    setTimeout(() => {
      topLoading.classList.add("is-open");
    },500);

    setTimeout(() => {
      header.classList.add("is-open");
    },1300);

    setTimeout(() => {
      humMenu.classList.add("is-open");
    },1300);

    setTimeout(() => {
      sideTxt.classList.add("is-open");
    },1300);

    setTimeout(() => {
      mv.classList.add("is-open");
    },1500);
  }
}
class WorksSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const el = document.querySelector('.s-works__swiper-button-next-circle .circle');
    const speed = 5000;
    
    const swiper = new Swiper(".s-works__swiper", {
      slidesPerView: 1.05,
      spaceBetween: 24,
      speed: 500,
      loop: true,
      autoplay: {
        delay: speed,
        disableOnInteraction: false,
      },
      
      on: {
        slideChangeTransitionStart: function () {
          el.style.transitionDuration = '0.5s',
          el.style.strokeDashoffset = '264px'
        },

        slideChangeTransitionEnd: function () {
          el.style.transitionDuration = speed + 'ms',
          el.style.strokeDashoffset = '0'
        },
      },
      
      breakpoints: {
        768: {
          spaceBetween: 50,
          slidesPerView: 2.2,
        },
      },

      scrollbar: {
        el: ".s-works__swiper-scrollbar",
        draggable: true 
      },
    
      // ナビボタンが必要なら追加
      navigation: {
        nextEl: ".s-works__swiper-button-next",
        prevEl: ".s-works__swiper-button-prev",
        clickable: true,
      },
    });
  }
}


(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {
  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let common = new Common('c-content');
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  let formCheckbox = new FormCheckbox('js-mw-checkbox');
  let mvSwiper = new MvSwiper('s-mv'); 
  let worksSwiper = new WorksSwiper('s-works__swiper'); 
  let serviceSwiper = new ServiceSwiper('s-service__swiper'); 
  let singleWorkSwiper = new SingleWorkSwiper('p-single-swiper'); 
  let hamburgerMenu = new HamburgerMenu('js-hum');
  let splitText = new SplitText('js-splitText');
  let topLoading = new TopLoading('topLoading');
  let works = new Works('c-works');

  

  // 以下ページビルダー用
  let accordion = new Accordion('c-accordion');
  let modal = new Modal('c-modal-trigger');
  let tab = new Tab('c-tab-trigger');
  let swiper = new Slider('c-swiper');
  let loading = new Loading('c-loading');
  let editor = new Editor('c-editor');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });